import { useAtom } from '@reatom/npm-react'
import styled from 'styled-components'
import { match } from 'ts-pattern'

import { Trend } from '@root/entities/trend'
import { PnlUsdFormatted } from '@root/shared/core/format'

import type {
  AggregatedPositionModel,
  WalletPositionModel,
} from '@root/entities/position'
import type { ClassNameProps } from '@root/shared/react'

type ProfilePositionsTablePnlCellProps = {
  position: WalletPositionModel | AggregatedPositionModel
} & ClassNameProps

export const ProfilePositionsTablePnlCell: React.FC<
  ProfilePositionsTablePnlCellProps
> = ({ className, position }) => {
  const [pnlUsd] = useAtom(position.pnlUsd)

  const pnlValue = pnlUsd.pnlUsd
  const pnlPercent = pnlUsd.pnlPercentage

  return (
    <Root className={className} $trend={Trend.of(pnlPercent)}>
      <Amount>
        <PnlUsdFormatted pnl={pnlValue} />
      </Amount>
    </Root>
  )
}

const Root = styled.div<{ $trend: Trend.Trend }>`
  display: grid;
  gap: 1px;

  color: ${({ $trend }) =>
    match($trend)
      .with(Trend.Up, () => 'var(--up-9)')
      .with(Trend.Down, () => 'var(--down-9)')
      .with(Trend.Neutral, () => 'var(--neutral-9)')
      .exhaustive()};
`

const Amount = styled.div`
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;

  display: grid;
  grid-auto-flow: column;
  align-items: center;
  justify-content: start;
  gap: 2px;
`
